import graphqlClient from "../../../apollo";

class PromoProvider {

    findPromo(id) {
        return graphqlClient.query({
            query: require('./gql/Promo/findPromo.graphql'),
            variables: {id:id},
            fetchPolicy: "network-only"
        })
    }

    fetchPromo() {
        return graphqlClient.query({
        query: require('./gql/Promo/fetchPromo.graphql'),
        fetchPolicy: "network-only"
        })
    }
    
    paginatePromo(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Promo/paginatePromo.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }
    
    

    createPromo(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Promo/createPromo.graphql'),
            variables: {input}
        })
    }
    
    updatePromo(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Promo/updatePromo.graphql'),
            variables: {id, input}
        })
    }
    
     deletePromo(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Promo/deletePromo.graphql'),
            variables: {id}
        })
    }

}

export default new PromoProvider()


